module.exports = require("./../../_gen/openfl/ui/GameInputDevice");